jQuery(document).ready(function ($) {

    let counterRAF = null;

    function animateCounter(from, to, duration = 1000) {
        // annule l'animation de compteur en cours pour repartir de zéro
        if (counterRAF) {
            cancelAnimationFrame(counterRAF);
            counterRAF = null;
        }

        const startTime = performance.now();

        function update(currentTime) {
            const progress = Math.min((currentTime - startTime) / duration, 1);
            const value = Math.floor(from + (to - from) * progress);
            $(".globalDate").text(value);
            if (progress < 1) {
                counterRAF = requestAnimationFrame(update);
            } else {
                $(".globalDate").text(to);
                counterRAF = null;
            }
        }

        counterRAF = requestAnimationFrame(update);
    }

    $(".bloc_timeline").each(function (index) {

        if ($(".bloc_timeline .container_slider_dates").length) {

            //init
            $(".pager_dates .pdate:first-child").addClass("active")
            let d = $(".pager_dates .pdate:first-child").data("date")
            $(".globalDate").html(d)

            // largeur d'un slide, relue à chaque déplacement pour suivre les
            // changements de largeur (rotation d'écran, redimensionnement)
            function largeurSlide() {
                return $(".bloc_timeline .slider_dates .date").first().outerWidth() || $(".pager_dates").width()
            }

            // click : équivalent au tap sur mobile, ignoré si la date est déjà active
            // (le tap déclenche aussi un mouseenter émulé juste avant)
            $('.pager_dates .pdate').on('mouseenter click', function (event) {
                if (event.type === 'click' && $(this).hasClass('active')) {
                    return
                }

                let dd = $(this).data("date")
                let ii = $(this).index()
                let w = largeurSlide()

                // repart de la valeur affichée pour interrompre proprement le compteur en cours
                let currentVal = parseInt($(".globalDate").text(), 10) || d
                animateCounter(currentVal, dd, 1000);

                $('.pager_dates .active').removeClass("active")
                $(this).addClass("active")

                // remplace le tween en cours au lieu de l'empiler dans une timeline
                gsap.to($(".bloc_timeline .container_slider_dates .slider_dates"), {
                    x: -(w * ii),
                    ease: "power1.inOut",
                    duration: 1,
                    overwrite: "auto"
                })

            })

            // recale le slider sur la date active après un redimensionnement
            let resizeTimer = null
            $(window).on('resize', function () {
                clearTimeout(resizeTimer)
                resizeTimer = setTimeout(function () {
                    let ii = $('.pager_dates .pdate.active').index()
                    gsap.set($(".bloc_timeline .container_slider_dates .slider_dates"), {
                        x: -(largeurSlide() * Math.max(ii, 0))
                    })
                }, 150)
            })

        }

    })

});